// extracted by mini-css-extract-plugin
export default {"container":"h1I6NqteN4eCUcPd1mzI"};